/*
 * Copyright (c) 2019 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import { LocaleProvider, ModelKeyProvider } from '@typescript-kit/core';
import { ValueModel } from './component-model/value.component-model';
import { ViewComponentKey } from './key/view-component.key';

// DYNAMIC IMPORT IS NOT WORKING WITH COMMONJS MODULE RESOLUTION
import { viewDeLocale } from './locale/de.locale';
import { viewEnLocale } from './locale/en.locale';

export class ViewInitializer {

  static initialize(): void {
    ViewInitializer.registerModelKeys();
    ViewInitializer.registerLocales();
  }

  static registerModelKeys() {
    ModelKeyProvider.registerKey(ValueModel, ViewComponentKey.VALUE);
  }

  static registerLocales() {
    LocaleProvider.registerPackageLocale('de', 'kit-view', viewDeLocale);
    LocaleProvider.registerPackageLocale('en', 'kit-view', viewEnLocale);
    // LocaleProvider.registerPackageLocale('de', 'kit-view', async () => {
    //   return import('./locale/de.locale').then((mod) => mod.viewDeLocale);
    // });
    // LocaleProvider.registerPackageLocale('en', 'kit-view', async () => {
    //   return import('./locale/en.locale').then((mod) => mod.viewEnLocale);
    // });
  }

}
